var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.isModal ? 'versus_action' : 'chat_action']},[_c('input',{attrs:{"type":"image","src":"static/images/versus_icon.svg","alt":"Submit"},on:{"click":function($event){$event.preventDefault();_vm.actionOnClick()}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08c7e0b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/shared/Versus.vue
// module id = null
// module chunks = 